// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","2682":"930df20d","3824":"81709065"}[chunkId] + ".css";
};